import { Stack, Typography } from '@mui/material'
import React from 'react'

const MailboxInfo = ({mailbox}) => {
  const lastRefreshInHrs = Math.floor(
    Math.abs(new Date() - new Date(mailbox?.lastReset)) / 36e5
);
  const info= [
    {label: "Week", value: mailbox?.inWeek},
    {label: "Daily Emails Sent", value: mailbox?.emailsSent},
    {label: "Current Max Allowed", value: mailbox?.maxAllowed},
    {label: "Last Refresh", value: `${lastRefreshInHrs} ${lastRefreshInHrs > 1 ? "Hrs" : "Hr"} Ago`}
  ]
  return (
    <Stack spacing={1} sx={{ p: 2 }}>
      {info?.map((data, index) => (
        <Stack key={index} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={1}>
          <Typography 
            sx={{
              fontSize: "14px",
              fontWeight: 600
            }}
          >
            {data?.label}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {data?.value}
          </Typography>
        </Stack>
      ))}

    </Stack>
  )
}

export default MailboxInfo